import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";

import { useAuthStore } from "@/features/auth/store";

import { usesInsurance } from "../module";

/** Pages Assurances : le module doit être actif pour la clinique (ADR 0063).
 *  Les droits restent vérifiés par chaque page. */
export function InsuranceGuard({ children }: { children: ReactNode }) {
  const me = useAuthStore((s) => s.me);
  if (me && !usesInsurance(me)) return <Navigate to="/403" replace />;
  return <>{children}</>;
}
